import React from 'react';
import { Lock } from 'lucide-react';

export const EntityStatusBadge = ({ isActive }) => {
  if (isActive) return null;
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-gray-100 text-gray-700 text-xs rounded-md font-medium">
      <Lock size={10} />
      Passiv
    </span>
  );
};
